var ContentRouter = (function ($) {

    ContentRouter = function (options) {
        var that = this;

        // DOM
        that.$document = $(document);
        that.$window = $(window);
        that.$content = options['$content'];

        // VARS
        that.app_url = options['app_url'];
        that.base_href = (options['base_href'] || null);
        that.api_enabled = !!(window.history && window.history.pushState);

        // METHODS
        that.onLoad = (typeof options['onLoad'] === 'function' ? options['onLoad'] : function () {});
        that.onDone = (typeof options['onDone'] === 'function' ? options['onDone'] : function () {});
        that.onFail = (typeof options['onFail'] === 'function' ? options['onFail'] : function () {});

        // DYNAMIC VARS
        that.xhr = false;
        that.is_enabled = true;

        // predicate that says ignore routing by this router - for example if we want turn of whole design redactor section be handled by this router
        that.ignore = options.ignore;
        if (typeof that.ignore !== 'function') {
            delete that.ignore
        }

        // INIT
        that.initClass();
    };

    ContentRouter.prototype.initClass = function () {
        var that = this;

        //
        that.setupBaseHref();
        //
        that.bindEvents();
    };

    ContentRouter.prototype.setupBaseHref = function () {
        var that = this;

        if (!that.base_href) {
            return false;
        }

        var $base = $('base');
        if (!$base.length) {
            var base = document.createElement('base');
            document.getElementsByTagName('head')[0].appendChild(base);
            $base = $(base);
        }

        $base.attr('href', that.base_href);
    };

    ContentRouter.prototype.bindEvents = function () {
        var that = this;

        // When user clicks a link that leads to app backend, load content via XHR instead.
        var full_app_url = window.location.origin + that.app_url;

        that.$document.on('click', 'a', function (event) {
            // ignore routing
            if (that.ignore && that.ignore()) {
                return;
            }

            var $link = $(this),
                href = $link.attr('href');

            // hack for jqeury ui links without href attr
            if (!href) {
                $link.attr('href', 'javascript:void(0);');
                href = $link.attr('href');
            }

            var has_class_disable_router = $link.hasClass('js-disable-router'),
                has_class_one_time = $link.hasClass('js-one-time'),
                has_target_blank = $link.attr('target') === '_blank',
                is_app_url = (this.href.substr(0, full_app_url.length) == full_app_url),
                is_normal_url = (!(href.includes('#') || href.substr(0, 11) === 'javascript:')),
                use_content_router = (that.is_enabled && !has_class_disable_router && !has_target_blank && is_app_url && is_normal_url);
            
            if (has_class_one_time && !has_target_blank) {
                if ($link.hasClass('disabled')) {
                    event.preventDefault();
                    return;
                } else {
                    $link.addClass('disabled');
                }
            }

            if (!event.ctrlKey && !event.shiftKey && !event.metaKey && use_content_router) {
                event.preventDefault();

                var content_uri = this.href;
                that.load(content_uri);
            }
        });

        // Click on browser back button
        if (that.api_enabled) {
            window.onpopstate = function (event) {
                // ignore routing
                if (that.ignore && that.ignore()) {
                    return;
                }
                event.stopPropagation();
                that.onPopState(event);
            };
        }
    };

    ContentRouter.prototype.load = function (content_uri, unset_state) {
        var that = this;

        var uri_has_app_url = (content_uri.indexOf(that.app_url) >= 0);
        if (!uri_has_app_url) {
            window.location.href = content_uri
            return false;
        }

        if (that.xhr) {
            that.xhr.abort();
            that.$document.trigger('wa_abort');
        }

        that.$document.trigger('avia_before_load');
        that.$document.trigger('wa_before_load', {
            // for which these data ?
            content_uri: content_uri
        });

        if (that.api_enabled && !unset_state) {
            history.pushState({
                reload: true,               // force reload history state
                content_uri: content_uri    // url, string
            }, '', content_uri);
        }

        that.onLoad(that);

        that.xhr = $.ajax({
            method: 'GET',
            url: content_uri,
            dataType: 'html',
            global: false,
            cache: false,
            xhr: function () {
                let xhr = new XMLHttpRequest();
                xhr.addEventListener('progress', function (event) {
                    that.$document.trigger('wa_loading', event);
                }, false);
                xhr.addEventListener('abort', function (event) {
                    $.sa.log('abort', event);
                }, false);
                return xhr;
            }
        }).done(function (html) {
            that.setContent(html);
            that.xhr = false;
            setTimeout(function () {
                that.onDone(that);
                $.sa.analytics.hit(window.location.href, {});
                that.$document.trigger('wa_loaded');
                that.$document.trigger('avia_after_load');
            }, 0);
        }).fail(function (data) {
            $.sa.error('Error loading data from ', content_uri, data);
            setTimeout(function () {
                that.onFail(that);
                that.$document.trigger('wa_loaded');
                that.$document.trigger('avia_after_load');
            }, 0);

            if (data.status === 401) {
                location.reload(); // Hack for QRATOR antibot
            } else if (data.responseText) {
                that.setContent(data.responseText);
            }
        });

        return that.xhr;
    };

    ContentRouter.prototype.reload = function () {
        var that = this,
            content_uri = (that.api_enabled && history.state && history.state.content_uri) ? history.state.content_uri : location.href;

        if (content_uri) {
            return that.load(content_uri, true);
        } else {
            return $.when(); // a resolved promise
        }
    };

    ContentRouter.prototype.setContent = function (html) {
        var that = this;

        that.$document.trigger('wa_before_render');

        that.$content.html(html);
        window.scrollTo(0, 0);
    };

    ContentRouter.prototype.onPopState = function (event) {
        var that = this,
            state = (event.state || false);

        if (state) {
            that.$document.trigger('wa_before_load');

            // CONTENT
            if (state.content) {
                that.setContent(state.content);
            } else {
                that.reload();
            }

            if (state.title) {
                $.sa.title.set(state.title);
            }
            that.$document.trigger('wa_loaded');
        } else {
            if (window.location.href.indexOf('#') === -1) {
                location.reload();
            }
        }
    };

    return ContentRouter;

})(jQuery);
